var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"text-sm text-red-500 mb-4 list-inside",class:{'list-disc': _vm.errorsForDisplay && _vm.errorsForDisplay.length > 1}},_vm._l((_vm.errorsForDisplay),function(error,index){return _c('li',{key:index,domProps:{"textContent":_vm._s(error)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }